/** Piezas comunes de las pantallas del segundo factor (MfaEnroll y MfaChallenge). */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { normalizeCodeInput } from '../lib/mfa';

/** Pantalla cuando el token pendiente (5 min) ya no sirve: no hay nada que reintentar, hay que volver a iniciar sesion. */
export function SessionExpired({ message }: { message?: string }) {
  const nav = useNavigate();
  return (
    <div className="authwrap">
      <div className="authcard">
        <p className="muted" role="alert">{message ?? 'Su sesión de verificación expiró. Vuelva a iniciar sesión.'}</p>
        <button className="btn btn--primary" style={{ marginTop: 12 }} onClick={() => nav('/login', { replace: true })}>
          Volver al inicio de sesión
        </button>
      </div>
    </div>
  );
}

/**
 * Campo del codigo de 6 digitos. Sin `maxLength` a proposito: pegar "123 456" (como lo muestran algunas apps) lo cortaria
 * a "12345"; en su lugar se normaliza (lib/mfa.ts) y se avisa si se descarto algo. `error` es el rechazo del servidor.
 */
export function CodeField({
  id,
  label,
  value,
  onChange,
  error,
  autoFocus,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (code: string) => void;
  error?: string | null;
  autoFocus?: boolean;
}) {
  const [note, setNote] = useState<string | null>(null);
  const msg = error ?? note;
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        inputMode="numeric"
        autoComplete="one-time-code"
        autoFocus={autoFocus}
        value={value}
        aria-invalid={error ? true : undefined}
        aria-describedby={msg ? `${id}-msg` : undefined}
        onChange={(e) => {
          const r = normalizeCodeInput(e.target.value);
          setNote(r.note);
          onChange(r.code);
        }}
        style={{ fontSize: 18, letterSpacing: 4, textAlign: 'center' }}
      />
      {msg && (
        <div className="errmsg" id={`${id}-msg`} role={error ? 'alert' : undefined}>
          {msg}
        </div>
      )}
    </div>
  );
}
